// ReactSnap (postbuild prerendering) Chromium'da `navigator.userAgent === 'ReactSnap'`
// olarak çalışır. Build sırasında SPA canlı backend'e CORS reddedilen
// `http://localhost:PORT` origin'inden API istekleri atıyor. Bu helper
// prerendering esnasında API çağrılarını atlamamızı sağlar.
export const isPrerendering = () =>
  typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
